/* ============
 * State of formalities module
 * ============
 *
 * The initial state of the formalities module.
 */

export default {
  user: null
}



// WEBPACK FOOTER //
// ./src/store/modules/formalities/state.js